export default __webpack_public_path__ + "bfbd11c.png";